import { createUseStyles } from 'react-jss';

export const useSubCostCenterTableStyles = createUseStyles({
  selectColumnCell: {
    textAlign: 'center',
  },
});
